
  
        <div class="form-group formWrapper">
          <div class="row searchWrapper">
              
            <div style="display: flex; flex-direction: column; align-items: start;">
              <input type="text" 
                     id="scac"
                     class="form-control height-27 marTopLeft3510" 
                     [(ngModel)]="drsFilter.scac" 
                     (blur)="validateScac()"  
                     style="width: 97px; margin-left:35px; margin-top: 35px;" 
                     placeholder="scac" />
            
              <div *ngIf="isScacInvalid" 
                   style="color: red; font-size: 12px; margin-top: 3px; margin-left: 35px;">
                SCAC is mandatory.
              </div>
            </div>
  
              <div class="form-group hidden datePickerOpen">
                <div class="input-group">
                  <input name="datepicker" class="form-control" style="display: none;" ngbDatepicker
                    #datepicker="ngbDatepicker" [autoClose]="false"
                    (dateSelect)="onDateSelection($event); closeDatePicker && datepicker.toggle()" [displayMonths]="2"
                    [dayTemplate]="t" outsideDays="hidden" [startDate]="drsFilter.fromDate">
                  <ng-template #t let-date let-focused="focused">
                    <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                      [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                      (mouseleave)="hoveredDate = null">
                      {{ date.day }}
                    </span>
                  </ng-template>
                </div>
              </div>
              <div class="form-group height-27">
                <div class="input-group pointer marTopLeft3510" (click)="showOverlay = !showOverlay; datepicker.toggle()">
                  <label style="margin-top: 4px;">From : &nbsp;</label>
                  <input disabled #dpFromDate class="form-control height-27" placeholder="dd-MM-yy"
                    style="width: 97px; color: black; cursor: pointer"
                    (click)="showOverlay = !showOverlay; datepicker.toggle()" name="dpFromDate"
                    [value]="formatDateForDisplay(drsFilter.fromDate)"
                    (input)="drsFilter.fromDate = validateInput(drsFilter.fromDate, dpFromDate.value);">
  
                  <div class="input-group-append">
                    <button class="btn btn-outline-secondary calendar height-27" type="button">
                      <i class="fa fa-calendar" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-group ml-2 height-27">
                <div class="input-group pointer marTopLeft3510" (click)="showOverlay = !showOverlay; datepicker.toggle()">
                  <label style="margin-top: 4px;">To : &nbsp;</label>
                  <input #dpToDate disabled class="form-control height-27 pointer" placeholder="yyyy-mm-dd"
                    style="width: 97px; color: black" name="dpToDate" [value]="formatDateForDisplay(drsFilter.toDate)"
                    (change)="datepicker.toggle()" (input)="drsFilter.toDate = validateInput(drsFilter.toDate, dpToDate.value);">
                 
                </div>
              </div>
              <div class="form-group marTopLeft3510" style="margin-left: 25px;">
                <button class="btn height-27" style="background-color: #7cacd7;color: #fff;"
                  (click)="submitMethod()">Submit</button>
              </div>
            
          </div>
         <div class="align-items-center marTop30 marLeft50">
            <div class="align-self-center form-group marTop30 paginationWrapper" style="margin-left: 150px;">
              <nav class="" aria-label="Page navigation example text-center">
                <div class="text-center">
                  <div class="pagination row marTop70">
                    <div class="page-item marLeft540 marTop17" (click)="nextBtnClick(-1)">
                      <a href="javascript:void(0)" class="page-link left-traverse borderRadius5 button" [class.disabled]="page<=1">
                        < </a>
                    </div>
                    <div class="page-item marLeftNot42 marTop17"><a href="javascript:void(0)" style="height: 33px;">
                        <p style="margin-top: 0px;">
                          <input type="text" (change)="submitMethod()" [(ngModel)]="page" class="w-25 borderRadius5 marTop2">
                          <br>
                        <b>Page</b>
                        </p>
                      </a></div>
                    <div class="page-item marLeftNot42 marTop17"><a class="page-link right-traverse borderRadius5 button" href="javascript:void(0)"
                        (click)="nextBtnClick(+1)"> >
                      </a></div>
                    <div class="page-item marLeftNot42 marTop17"><a href="javascript:void(0)" style="height: 33px;">
                        <p style="margin-top: 0px;">
                         <input type="text" (change)="submitMethod()" class="w-25 borderRadius5 marTop2" [(ngModel)]="size">
                         <br>
                        <b>Size</b>
                        </p>
                      </a></div>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
  
        <div class="row"
        style="padding: 20px; margin-top: 30px;"
        *ngIf="!users || users.length == 0">
          <div class="col-12" >
            <i style="font-size: 12px;">** NOTE: Please input scac, from date and to date and hit submit button to view route specific info  !</i>
          </div>
        </div>
  
        <div class="table-responsive marTop30" *ngIf="users?.length > 0">
          <table id=" " class="table table-insurance-inner ">
            <thead class="header-user">
              <tr>
                <th class="wd-15p th-pd">Route ID</th>
                <th class="wd-15p th-pd">Route Status</th>
                <th class="wd-15p th-pd">Date </th>
                <th class="wd-15p th-pd">Driver Id</th>
                <th class="wd-15p th-pd">Driver</th>
                <th class="wd-15p th-pd">Device Name</th>
                <!-- <th class="wd-15p th-pd">Updated By</th> -->
                <!-- <th class="wd-15p th-pd">Last Activity</th> -->
                <th class="wd-15p th-pd">Scac</th>
                <th class="wd-15p th-pd">Punch In</th>
                <th class="wd-15p th-pd">Punch Out</th>
                
                <!-- <th class="wd-15p th-pd">Action</th> -->
  
              </tr>
            </thead>
            <tbody>
              <tr class="" *ngFor="let item of users">
                <td [ngStyle]="{
                  'background-color': (item?.routeStatus > 10 && item?.routeStatus < 20) ? '#d4edda' : 
                                      (item?.routeStatus > 20) ? '#e2e3e5' : 'transparent',
                  'color': (item?.routeStatus > 10 && item?.routeStatus < 20) ? '#155724' :
                           (item?.routeStatus > 20) ? '#6c757d' : 'black',
                  'font-weight': 'bold'
                }" (click)="redirectToBolScreen(item)"><a href="javascript:void(0)">{{item?.routeId}}</a></td>
                <!-- data-toggle="modal" data-target="#bolModal" -->
                <td [ngStyle]="{
                  'background-color': (item?.routeStatus > 10 && item?.routeStatus < 20) ? '#d4edda' : 
                                      (item?.routeStatus > 20) ? '#e2e3e5' : 'transparent',
                  'color': (item?.routeStatus > 10 && item?.routeStatus < 20) ? '#155724' :
                           (item?.routeStatus > 20) ? '#6c757d' : 'black',
                  'font-weight': 'bold'
                }">{{item?.routeStatus}}</td>
                <td>{{item?.date}}</td>
                <td>{{item?.driverId}}</td>
                <td><a href="javascript:void(0)" data-toggle="modal" data-target="#driverModal" (click)="redirectToDriverScreen(item)">{{item?.driverDTO.fname}} {{item?.driverDTO.lname}}</a></td>
                <!-- <td>{{ getCommaSeparatedValues(item?.deviceDTOs, 'deviceName') }}</td> -->
                 <td>
                  <div class="d-flex flex-wrap">
                    <div 
                      *ngFor="let device of item?.deviceDTOs" 
                      class="device-card pointer m-2" 
                      style="cursor: pointer; width: 50px; height: 50px; background-color: #f0f8ff; font-size: 9px;" 
                      (click)="openDeviceModal(device)">
                      <div class="card-body">
                        <a href="javascript:void(0)" data-toggle="modal" data-target="#deviceModal">{{device?.deviceUser}}</a>
                      </div>
                    </div>
                  </div>
                 </td>
                <!-- <td>{{ getCommaSeparatedValues(item?.deviceDTOs, 'deviceCode') }}</td>
                <td>{{ getCommaSeparatedValues(item?.deviceDTOs, 'mobileAppVersion') }}</td> -->
                <!-- <td>{{ getCommaSeparatedValues(item?.deviceDTOs, 'updatedBy') }}</td> -->
                <!-- <td>{{ getCommaSeparatedValues(item?.deviceDTOs, 'lastActivity') }}</td> -->
                <td>{{item?.scac}}</td>
                <td>{{item?.punchIn || 'N/A'}}</td>
                <td>{{item?.punchOut || 'N/A'}}</td>
                <!-- <td><a href="javascript:void(0)"><i class="fa fa-pencil-square-o drug-ins-action" aria-hidden="true"
                  data-toggle="modal" data-target="#addUserSelector" (click)="redirectToEditScreen(item)"></i></a></td> -->
              </tr>
            </tbody>
          </table>
        </div>
  
        <div class="align-items-center marTopNot30">
          <div class="align-self-center form-group marTop30 paginationWrapper" style="margin-left: 150px;">
            <nav class="" aria-label="Page navigation example text-center">
              <div class="text-center">
                <div class="pagination row marLeft70">
                  <div class="page-item marLeft540 marTop17" (click)="nextBtnClick(-1)">
                    <a href="javascript:void(0)" class="page-link left-traverse borderRadius5 button" [class.disabled]="page<=1">
                      <i class="fa fa-angle-left"></i> </a>
                  </div>
                  <div class="page-item marLeftNot42 marTop17"><a href="javascript:void(0)" style="height: 33px;">
                      <p style="margin-top: 0px;">
                        <input type="text" (change)="submitMethod()" [(ngModel)]="page" class="w-25 borderRadius5 marTop2">
                        <br>
                        <b>Page</b>
                      </p>
  
                    </a></div>
                  <div class="page-item marLeftNot42 marTop17"><a class="page-link right-traverse borderRadius5 button" href="javascript:void(0)"
                      (click)="nextBtnClick(+1)"> >
                    </a></div>
                  <div class="page-item marLeftNot42 marTop17"><a href="javascript:void(0)" style="height: 33px;">
                      <p style="margin-top: 0px;">
                       <input type="text" (change)="submitMethod()" class="w-25 borderRadius5 marTop2" [(ngModel)]="size">
                       <br>
                       <b>Size</b>
                      </p>
                    </a></div>
                </div>
              </div>
            </nav>
          </div>
        </div>
  
      


  <div class="modal fade" id="driverModal" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Driver Details</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <table class="table table-striped">
            <tbody>
              <tr>
                <td><strong>Driver Name</strong></td>
                <td>{{ selectedRecord?.fname }} {{ selectedRecord?.lname }}</td>
              </tr>
              <tr>
                <td><strong>User ID</strong></td>
                <td>{{ selectedRecord?.userID }}</td>
              </tr>
              <tr>
                <td><strong>Password</strong></td>
                <td>{{ selectedRecord?.mobilepassword }}</td>
              </tr>
              <tr>
                <td><strong>Update Source</strong></td>
                <td>{{ selectedRecord?.updatesource }}</td>
              </tr>
              <tr>
                <td><strong>Timestamp</strong></td>
                <td>{{ selectedRecord?.tstamp }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
  


  <div class="modal fade" id="bolModal" class="modal fade" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content bol-modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Bill of Lading Details</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <table class="table table-bordered table-insurance-inner">
            <thead class="thead-dark">
              <tr>
                <th class="wd-15p th-pd">BOL ID</th>
                <th class="wd-15p th-pd">Trip No</th>
                <th class="wd-15p th-pd">Dealer</th>
                <th class="wd-15p th-pd">Schedule Date</th>
                <th class="wd-15p th-pd">Truck ID</th>
                <th class="wd-15p th-pd">BOL Status</th>
                <th class="wd-15p th-pd">Multiple Suppliers</th>
                <th class="wd-15p th-pd">At Rack</th>
                <th class="wd-15p th-pd">Left Rack</th>
                <th class="wd-15p th-pd">At Location</th>
                <th class="wd-15p th-pd">Left Location</th>
                <th class="wd-15p th-pd">View Details</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let bol of billOfLadingList">
                <tr>
                  <td>{{ bol.billOfLadingId }}</td>
                  <td>{{ bol.tripNo }}</td>
                  <td>{{ bol.dealer || 'N/A' }}</td>
                  <td>{{ bol.scheduleDate }}</td>
                  <td>{{ bol.truck }}</td>
                  <td>{{ bol.bolstatus }}</td>
                  <td>{{ bol.multipleSuppliers ? 'Yes' : 'No' }}</td>
                  <td>{{ bol.arrivedAtRackTime || 'N/A' }}</td>
                  <td>{{ bol.leftRackTime || 'N/A' }}</td>
                  <td>{{ bol.arrivedAtCustomerTime || 'N/A' }}</td>
                  <td>{{ bol.finalizedDeliveryTime || 'N/A' }}</td>
                  <td>
                    <button class="btn btn-sm btn-primary" (click)="bol.showDetails = !bol.showDetails">
                      {{ bol.showDetails ? '-' : '+' }}
                    </button>
                  </td>
                </tr>
  
                <tr *ngIf="bol.showDetails">
                  <td colspan="12">
                    <!-- <h6>Bill of Lading Details:</h6> -->
                    <table class="table table-sm">
                      <thead>
                        <tr>
                          <th class="black-font">Detail ID</th>
                          <th class="black-font">Terminal</th>
                          <th class="black-font">Quantity</th>
                          <th class="black-font">Ordered Quantity</th>
                          <th class="black-font">Net Gallons</th>
                          <th class="black-font">Product ID</th>
                          <th class="black-font">Driver Confirmed</th>
                          <th class="black-font">End Load Time</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let detail of bol.billofladingdetails">
                          <td>{{ detail.detailID }}</td>
                          <td>{{ detail.terminal }}</td>
                          <td>{{ detail.quantity }}</td>
                          <td>{{ detail.ordered }}</td>
                          <td>{{ detail.netGallons }}</td>
                          <td>{{ detail.productId }}</td>
                          <td>{{ detail.driverconfirmed }}</td>
                          <td>{{ detail.boldetailsEndLoadTime }}</td>
                        </tr>
                      </tbody>
                      
                    </table>
                    <div *ngIf="bol.billofladingdetails?.length == 0">
                      <tr class="text-center">No bill of lading details available!</tr>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
          <div *ngIf="billOfLadingList?.length == 0">
            <tr class="text-center">No bill of lading available!</tr>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
  
  
  <div class="modal fade" id="deviceModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Device Details</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <table class="table table-striped">
            <tbody>
              <tr>
                <td>Device ID</td>
                <td>{{ selectedDevice?.deviceId }}</td>
              </tr>
              <tr>
                <td>Device Name</td>
                <td>{{ selectedDevice?.deviceName }}</td>
              </tr>
              <tr>
                <td>Device Code</td>
                <td>{{ selectedDevice?.deviceCode }}</td>
              </tr>
              <tr>
                <td>Is Active</td>
                <td>{{ selectedDevice?.isActive }}</td>
              </tr>
              <tr>
                <td>Last Activity</td>
                <td>{{ selectedDevice?.lastActivity }}</td>
              </tr>
              <tr>
                <td>Mobile App Version</td>
                <td>{{ selectedDevice?.mobileAppVersion }}</td>
              </tr>
              <tr>
                <td>Device User</td>
                <td>{{ selectedDevice?.deviceUser }}</td>
              </tr>
              <tr>
                <td>Created Date</td>
                <td>{{ selectedDevice?.createdDate }}</td>
              </tr>
              <tr>
                <td>Updated By</td>
                <td>{{ selectedDevice?.updatedBy }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
  
  